export const NFT_ADDRESS = '0xa68b206e00D585beA0a5dD0E9b6B56417506ab99';

export const NFT_ABI = [
  {
    "inputs": [
      { "name": "receiver", "type": "address" },
      { "name": "tokenId", "type": "uint256" },
      { "name": "quantity", "type": "uint256" },
      { "name": "currency", "type": "address" },
      { "name": "pricePerToken", "type": "uint256" },
      { 
        "components": [
          { "name": "proof", "type": "bytes32[]" },
          { "name": "quantityLimitPerWallet", "type": "uint256" },
          { "name": "pricePerToken", "type": "uint256" },
          { "name": "currency", "type": "address" }
        ],
        "name": "allowlistProof",
        "type": "tuple"
      },
      { "name": "data", "type": "bytes" }
    ],
    "name": "claim",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [{"name": "tokenId", "type": "uint256"}],
    "name": "uri",
    "outputs": [{"type": "string"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"name": "tokenId", "type": "uint256"}],
    "name": "totalSupply",
    "outputs": [{"type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"name": "tokenId", "type": "uint256"}],
    "name": "maxTotalSupply",
    "outputs": [{"type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [{"name": "tokenId", "type": "uint256"}],
    "name": "getActiveClaimConditionId",
    "outputs": [{"type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {"name": "tokenId", "type": "uint256"},
      {"name": "conditionId", "type": "uint256"}
    ],
    "name": "getClaimConditionById",
    "outputs": [{
      "components": [
        {"name": "startTimestamp", "type": "uint256"},
        {"name": "maxClaimableSupply", "type": "uint256"},
        {"name": "supplyClaimed", "type": "uint256"},
        {"name": "quantityLimitPerWallet", "type": "uint256"},
        {"name": "merkleRoot", "type": "bytes32"},
        {"name": "pricePerToken", "type": "uint256"},
        {"name": "currency", "type": "address"},
        {"name": "metadata", "type": "string"}
      ],
      "name": "condition",
      "type": "tuple"
    }],
    "stateMutability": "view",
    "type": "function"
  }
]; 